module.exports = __webpack_public_path__ + "static/media/Editar.617d0cc4.svg";